var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { FormGroup, FormControl, Validators } from "@angular/forms";
var TransplantReportFormGroup = /** @class */ (function (_super) {
    __extends(TransplantReportFormGroup, _super);
    function TransplantReportFormGroup() {
        var _this = this;
        var controlSet = {
            startDate: new FormControl(null, Validators.required),
            endDate: new FormControl(null, Validators.required),
            crop: new FormControl(),
            containerType: new FormControl(),
            substrate: new FormControl()
        };
        _this = _super.call(this, controlSet) || this;
        _this._startDate = controlSet.startDate;
        _this._endDate = controlSet.endDate;
        _this._crop = controlSet.crop;
        _this._containerType = controlSet.containerType;
        _this._substrate = controlSet.substrate;
        return _this;
    }
    Object.defineProperty(TransplantReportFormGroup.prototype, "startDateFormControl", {
        get: function () {
            return this._startDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransplantReportFormGroup.prototype, "endDateFormControl", {
        get: function () {
            return this._endDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransplantReportFormGroup.prototype, "cropFormControl", {
        get: function () {
            return this._crop;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransplantReportFormGroup.prototype, "containerTypeFormControl", {
        get: function () {
            return this._containerType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TransplantReportFormGroup.prototype, "substrateFormControl", {
        get: function () {
            return this._substrate;
        },
        enumerable: true,
        configurable: true
    });
    return TransplantReportFormGroup;
}(FormGroup));
export { TransplantReportFormGroup };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/reporting/transplant-report-form/transplant-report-form-group.ts.pre-build-optimizer.js